<fieldset><legend>{{ 'tags.whose' | translate }}</legend>
 <div class="author-options">
  <label><input type="radio" [name]="groupName" [checked]="!value.allAuthors && !value.authorIds.length" (change)="choose('mine')" />{{ 'tags.mine' | translate }}</label>
  <label><input type="radio" [name]="groupName" [checked]="value.allAuthors" (change)="choose('all')" />{{ 'tags.allAuthors' | translate }}</label>
  <sm-action-button variant="secondary" size="sm" [ariaExpanded]="expanded" (click)="open()">{{ 'tags.chooseAuthors' | translate }} @if (value.authorIds.length) { ({{ value.authorIds.length }}) }</sm-action-button>
 </div>
 @if (expanded) {
  <sm-input [label]="'tags.authorName' | translate" [ngModelOptions]="{standalone: true}" [(ngModel)]="query" (keydown.enter)="$event.preventDefault(); load()" />
  <sm-action-button variant="secondary" size="sm" [disabled]="loading" (click)="load()">{{ 'tags.find' | translate }}</sm-action-button>
  @if (loading) { <p role="status">{{ 'tags.loading' | translate }}</p> }
  @if (error) { <p role="alert">{{ 'tags.loadError' | translate }}</p> }
  @if (!loading && !error && !authors.length) { <p>{{ 'tags.noAuthors' | translate }}</p> }
  <div class="author-options">@for (author of authors; track author.id) {
   <label><input type="checkbox" [disabled]="!selected(author.id) && value.authorIds.length >= 100" [checked]="selected(author.id)" (change)="toggle(author)" />{{ author.name }}</label>
  }</div>
  @if (more) { <sm-action-button variant="secondary" size="sm" [disabled]="loading" (click)="load(true)">{{ 'tags.more' | translate }}</sm-action-button> }
 }
</fieldset>

